import { isString } from './shared';

export const getFromLocalStorage = (key: string) => {
  const value = localStorage.getItem(key);

  if (!value) return null;

  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};

export const setToLocalStorage = (
  key: string,
  value: string | boolean | number | Record<string, unknown>,
) => {
  if (isString(value)) {
    localStorage.setItem(key, value);
    return;
  }

  localStorage.setItem(key, JSON.stringify(value));
};
